import app from '@/app';
import templateUrl from './constant-button.html';


  app.component('prConstantButton', {
    templateUrl,
    bindings: {
      type: '@',
      state: '@',
      params: '<'
    }
  });
